import { render } from "./DeleteHoliday.vue?vue&type=template&id=607a6b8a"
import script from "./DeleteHoliday.vue?vue&type=script&lang=js"
export * from "./DeleteHoliday.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__